import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export interface YouTubeOptimization {
  titles: string[];
  description: string;
  tags: string[];
  thumbnailIdeas: Array<{
    type: string;
    title: string;
    description: string;
    elements: any;
  }>;
  chapters: Array<{
    time: string;
    title: string;
    duration: number;
  }>;
}

export interface YouTubeOptimizationResponse {
  success: boolean;
  data: YouTubeOptimization;
  error?: string;
}

export class YouTubeService {
  /**
   * 유튜브 최적화 가져오기
   */
  async getOptimization(
    keyword: string,
    script: string,
    metadata: any = {}
  ): Promise<YouTubeOptimization> {
    try {
      const response = await apiClient.post<YouTubeOptimizationResponse>(
        '/v2/youtube/optimize',
        {
          keyword,
          script,
          metadata,
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.error || '유튜브 최적화를 가져오는데 실패했습니다.');
      }

      return response.data.data;
    } catch (error: any) {
      console.error('YouTube optimization error:', error);
      throw new Error(error.response?.data?.error || '유튜브 최적화를 가져오는데 실패했습니다.');
    }
  }
}

export const youtubeService = new YouTubeService();

